export const format = ({ date, year = 'numeric', month = 'short', day = '2-digit', hour, minute, second }) => {
    let objDate = date
    if (typeof date === 'string') {
        let withoutISO = date.replace('Z', '')
        objDate = new Date(withoutISO)
    }
    let ye = new Intl.DateTimeFormat('es', { year }).format(objDate);
    let mo = new Intl.DateTimeFormat('es', { month }).format(objDate);
    let da = new Intl.DateTimeFormat('es', { day }).format(objDate);
    let result = `${ye}-${mo}-${da}`
    if (hour && minute && second) {
        let ho = new Intl.DateTimeFormat('es', { hour, minute, second }).format(objDate);
        result = `${result} ${ho}`
    }

    return result;
}